var timer = null;

// 节流函数
var throttle = function throttle(fn) {
  var delay = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : 1000;
  return function () {
    for (var _len = arguments.length, args = new Array(_len), _key = 0; _key < _len; _key++) {
      args[_key] = arguments[_key];
    }
    if (!timer) {
      //没有标识创建标识，有标识不再触发
      timer = setTimeout(function () {
        // 定时清除标识，重新触发
        fn(args);
        timer = null;
      }, delay);
    }
  };
};
export default throttle;